import React from 'react'
import parse from 'html-react-parser';

export default function ({topCallout, data}) {
  return (
    <div className='calloutBox'>
      <div className="calloutBox__content">
        <div className='topCallout'>
          {parse(topCallout)}
        </div>

        <div className='calloutData'>
          <table>
            {Object.keys(data).map(item => (
              <tbody key={item}>
                <tr>
                  <th>{item}</th>
                  <td>{data[item]}</td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
      </div>
    </div>
  )
}
